import { GasStationBrand } from "@1games-ru/region-shared/dist/enums/estate/gas-station";

export const brandColor: Record<GasStationBrand, string> = {
  [GasStationBrand.Gaspro]: "#0079C2",
  [GasStationBrand.Luoil]: "#ED1B34",
  [GasStationBrand.Russeti]: "#0067DB",
};
